import { Route } from 'react-router-dom';
import { Suspense, lazy } from 'react';

// Lazy load legal pages
const MentionsLegales = lazy(() => import('@/pages/MentionsLegales'));
const PolitiqueConfidentialite = lazy(() => import('@/pages/PolitiqueConfidentialite'));
const CGV = lazy(() => import('@/pages/CGV'));
const CGU = lazy(() => import('@/pages/CGU'));
const ReglementInterieur = lazy(() => import('@/pages/ReglementInterieur'));
const CertificatQualiopi = lazy(() => import('@/pages/CertificatQualiopi'));

const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center">
    Chargement...
  </div>
);

export function LegalRoutes() {
  return (
    <>
      <Route 
        path="/mentions-legales" 
        element={
          <Suspense fallback={<PageLoader />}>
            <MentionsLegales />
          </Suspense>
        } 
      />
      <Route 
        path="/politique-confidentialite" 
        element={
          <Suspense fallback={<PageLoader />}>
            <PolitiqueConfidentialite />
          </Suspense>
        } 
      />
      <Route 
        path="/cgv" 
        element={
          <Suspense fallback={<PageLoader />}>
            <CGV />
          </Suspense>
        } 
      />
      <Route 
        path="/cgu" 
        element={
          <Suspense fallback={<PageLoader />}>
            <CGU />
          </Suspense>
        } 
      />
      <Route 
        path="/reglement-interieur" 
        element={
          <Suspense fallback={<PageLoader />}>
            <ReglementInterieur />
          </Suspense>
        } 
      />
      <Route 
        path="/certificat-qualiopi" 
        element={
          <Suspense fallback={<PageLoader />}>
            <CertificatQualiopi />
          </Suspense>
        } 
      />
    </>
  );
}
